<template>
    <ClientSummary
        v-if="!isError.hasError && !isLoading"
        :client="infoClient"
        :ui="ui"
        :balance="infoClient.total"
        :status-class="typeClassConvenio"
        @back="$emit('back')"
    />
    <div class="container_submenu" v-if="!isError.hasError && !isLoading">
        <header>
            <v-card-title>Domicilio Aval</v-card-title>
            <v-divider class="mx-3"></v-divider>
        </header>
        <div class="content_accion">
            <div>
                <v-text-field
                    v-model="searchDireccionesAvales"
                    label="Búsqueda"
                    prepend-inner-icon="mdi-magnify"
                    single-line
                    variant="outlined"
                    hide-details
                    class="filter"
                    :disabled="isLoading"
                ></v-text-field>
            </div>
            <div>
                <v-btn
                    icon="mdi-reload"
                    size="small"
                    variant="outlined"
                    color="indigo-darken-3"
                    class="mr-2"
                    :disabled="isLoading"
                    @click="getDirectionsAvalByClient()"
                ></v-btn>
                <v-btn
                    prepend-icon="mdi-plus"
                    color="indigo-darken-3"
                    class="elevation-0 text-none"
                    @click="dialogDirectionAval = true; typeFormDirectionAval.type = 'R';"
                    :disabled="isLoading"
                    text="Registrar"
                ></v-btn>
            </div>
        </div>
        <v-data-table
            :headers="dataSourceDireccionesAvales.headers"
            :items="dataSourceDireccionesAvales.data"
            :search="searchDireccionesAvales"
            :loading="isLoading"
            no-data-text="Sin datos para mostrar"
            loading-text="Cargando información... Espere un momento"
        >
            <template v-slot:[`item.actions`]="{ item }">
                <td>
                    <v-tooltip text="Eliminar" location="bottom" v-if="permissions">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                v-bind="props"
                                class="elevation-0"
                                density="comfortable"
                                icon="mdi-delete"
                                color="error"
                                :disabled="isLoadingListaTelefono || isLoading"
                                @click="deleteAval(item)"
                            ></v-btn>
                        </template>
                    </v-tooltip>
                </td>
            </template>
        </v-data-table>
    </div>
    <div v-if="isError.hasError && !isLoading" class="has_error">
        <div>
            <img src="@/assets/images/hasError.svg">
        </div>
        <div>{{ isError.msg }}</div>
    </div>
    <div v-if="isLoading" class="content_load h-100" >
        <v-progress-circular
            :size="100"
            :width="7"
            color="indigo-darken-3"
            indeterminate
        ></v-progress-circular>
        <i>Espere un Momento</i>
        <div>Cargando la Información de los Domicilios Avales</div>
    </div>

    <template>
        <v-dialog v-model="dialogDirectionAval" width="550px" persistent>
            <v-card>
            <v-card-title>
                <span class="text-h5">{{ typeFormDirectionAval.type === 'R' ? 'Registro de Domicilio Aval' : 'Modificación de Domicilio Aval' }}</span>
            </v-card-title>
            <v-card-text>
                <form class="override_content_flex">
                    <div class="col-flex-6">
                        <v-text-field 
                        label="Nombre del Aval" 
                        variant="outlined" 
                        class="w-100"
                        rows="2"
                        v-model="formGroupDireccionAvales.data.nombre_aval"
                        :rules="formGroupDireccionAvales.rules.nombre_aval">
                        </v-text-field>
                    </div>
                    <div class="col-flex-6">
                        <v-text-field 
                        label="Teléfono" 
                        type="number"
                        variant="outlined" 
                        class="w-100"
                        maxlength="10"
                        v-on:input="limitarTelDireccionAval"
                        v-model="formGroupDireccionAvales.data.telefono"
                        :rules="formGroupDireccionAvales.rules.telefono"
                        onkeydown="return event.key !== 'e'"
                        ></v-text-field>
                    </div>
                    <div class="col-flex-6">
                        <v-text-field 
                        label="Domicilio" 
                        variant="outlined" 
                        class="w-100"
                        v-model="formGroupDireccionAvales.data.direccion"
                        :rules="formGroupDireccionAvales.rules.direccion">
                        </v-text-field>
                    </div>
                    <div class="col-flex-6">
                        <v-text-field 
                        label="Número Exterior" 
                        variant="outlined" 
                        class="w-100"
                        v-model="formGroupDireccionAvales.data.num_ext"
                        :rules="formGroupDireccionAvales.rules.num_ext">
                        </v-text-field>
                    </div>
                    <div class="col-flex-6">
                        <v-text-field 
                        label="Número Interior" 
                        variant="outlined" 
                        class="w-100"
                        v-model="formGroupDireccionAvales.data.num_int"
                        :rules="formGroupDireccionAvales.rules.num_int">
                        </v-text-field>
                    </div>
                    <div class="col-flex-6">
                        <v-text-field
                        label="Código Postal" 
                        type="number" 
                        variant="outlined"
                        class="w-100"
                        v-model="formGroupDireccionAvales.data.cp"
                        :rules="formGroupDireccionAvales.rules.cp"
                        v-on:input="limitarCPDireccionAval"
                        onkeydown="return event.key !== 'e'"
                        ></v-text-field>
                    </div>
                    <div class="col-flex-6">
                        <v-text-field 
                        label="Colonia" 
                        variant="outlined" 
                        class="w-100"
                        v-model="formGroupDireccionAvales.data.colonia"
                        :rules="formGroupDireccionAvales.rules.colonia">
                        </v-text-field>
                    </div>
                    <div class="col-flex-6">
                        <v-text-field 
                        label="Población" 
                        variant="outlined" 
                        class="w-100"
                        v-model="formGroupDireccionAvales.data.poblacion"
                        :rules="formGroupDireccionAvales.rules.poblacion">
                        </v-text-field>
                    </div>
                    <div class="col-flex-6">
                        <v-text-field 
                        label="Estado" 
                        variant="outlined" 
                        class="w-100"
                        v-model="formGroupDireccionAvales.data.estado"
                        :rules="formGroupDireccionAvales.rules.estado">
                        </v-text-field>
                    </div>
                    <div class="col-flex-6">
                        <v-select
                        label="Tipo de Relación" 
                        variant="outlined" 
                        class="w-100"
                        :items="[{key: 'familiar', value: 'Familiar'},{key: 'externo', value: 'Externo'}]"
                        item-title="value"
                        item-value="key"
                        v-model="formGroupDireccionAvales.data.tipo_relacion"
                        :rules="formGroupDireccionAvales.rules.tipo_relacion">
                        </v-select>
                    </div>
                </form>
            </v-card-text>
            <v-card-actions class="actions_buttons" v-if="!isLoading">
                <v-btn 
                    variant="flat"
                    class="text-none"
                    color="red"
                    @click="dialogDirectionAval = false; clearFormDirectionAval();"
                    text="Cerrar"
                ></v-btn>
                <v-btn 
                    variant="flat"
                    class="text-none"
                    color="indigo-darken-3"
                    :disabled="!validateFormDirectionAval() || isLoading" 
                    @click="dialogSaveDirectionAval = true"
                    text="Guardar"
                ></v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
    </template>

    <template>
        <v-dialog v-model="dialogSaveDirectionAval" width="500px" persistent>
            <v-card>
                <v-card-title>
                    <span class="text-h5">Confirmación</span>
                </v-card-title>
                <v-card-text>
                    <div v-if="!isLoading">
                        <div class="text-center">
                            <img src="@/assets/images/warning.png">
                        </div>
                        <div class="description-text">
                            <p v-if="typeFormDirectionAval.type === 'R'">¿Está seguro de registrar la dirección del aval?</p>
                            <!-- <p v-if="typeFormDirectionAval.type === 'M'">¿Está seguro de modificar la dirección del aval?</p> -->
                            <p v-if="typeFormDirectionAval.type === 'D'">¿Está seguro de eliminar la dirección del aval?</p>
                        </div>
                    </div>
                    <div class="content_load" v-if="isLoading">
                        <v-progress-circular
                            :size="100"
                            :width="7"
                            color="indigo-darken-3"
                            indeterminate
                        ></v-progress-circular>
                        <i>Espere un momento</i>
                        <div>Cargando la información</div>
                    </div>
                </v-card-text>
                <v-card-actions class="actions_buttons" v-if="!isLoading">
                    <v-btn 
                        variant="flat"
                        class="text-none"
                        color="red"
                        @click="dialogSaveDirectionAval = false"
                        text="Cerrar"
                    ></v-btn>
                    <v-btn
                        variant="flat"
                        class="text-none"
                        color="indigo-darken-3"
                        v-if="typeFormDirectionAval.type === 'R'"
                        @click="createDirectionClientAval()" 
                        :loading="isLoadingDirecciones"
                        text="Guardar"
                    ></v-btn>
                    <v-btn
                        variant="flat"
                        class="text-none"
                        color="indigo-darken-3"
                        v-if="typeFormDirectionAval.type === 'D'"
                        @click="deleteDirectionClientAval()" 
                        :loading="isLoadingDirecciones"
                        text="Guardar"
                    ></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </template>
    <SnackbarComponent :value="snackbarData"/>
</template>
<script>
import ClientSummary from '@/components/managements/ClientSummary.vue'
import { EncryptService } from '@/services/EncryptService'
import { ManagementsService } from '@/services/ManagementsService'
import SnackbarComponent from '@/components/Snackbar'
import { ResourcesService } from '@/services/ResourcesService'
import { useUiStore } from '@/stores/ui'
export default {
    name: "AddressEndorsementsView",
    emits: ['back'],
    props: {
        msg: String,
    },
    components: {
        ClientSummary,
        SnackbarComponent,
    },
    data() {
        return {
            idClient: null,
            isLoading: false,
            isError: {
                hasError: false,
                msg: '',
            },
            snackbarData: {
                openSnackbar: false,
                description: '',
            },
            searchDireccionesAvales: '',
            typeFormDirectionAval: {
                type: '',
                id: 0,
            },
            dialogDirectionAval: false,
            dialogSaveDirectionAval: false,
            dataSourceDireccionesAvales: {
                data: [],
                headers: [
                    { key: "nombre_aval", title: "Nombre Aval" },
                    { key: "direccion", title: "Domicilio" },
                    { key: "num_ext", title: "Numero Exterior" },
                    { key: "cp", title: "Código Postal" },
                    { key: "colonia", title: "Colonia" },
                    { key: "poblacion", title: "Población" },
                    { key: "estado", title: "Estado" },
                    { key: "agregado_por", title: "Agregado por" },
                    { key: "actions", title: "Acciones" },
                ],
            },
            isLoadingDirecciones: false,
            isLoadingListaTelefono: false,
            formGroupDireccionAvales: {
                data: {
                    direccion: '',
                    num_ext: '',
                    num_int: 'N/A',
                    cp: '',
                    colonia: '',
                    poblacion: '',
                    estado: '',
                    tipo_relacion: null,
                    telefono: '',
                    nombre_aval: '',
                },
                rules: {
                    direccion: [
                        value => {
                        if (value) {
                            return true
                        }
                        return 'El campo Domicilio es obligatorio'
                        }
                    ],
                    num_ext: [
                        value => {
                        if (value) {
                            return true
                        }
                        return 'El campo Número Exterior es obligatorio'
                        }
                    ],
                    cp: [
                        value => {
                        if (value) {
                            return true
                        }
                        return 'El campo Código Postal es obligatorio'
                        }
                    ],
                    colonia: [
                        value => {
                        if (value) {
                            return true
                        }
                        return 'El campo Colonia es obligatorio'
                        }
                    ],
                    poblacion: [
                        value => {
                        if (value) {
                            return true
                        }
                        return 'El campo Población es obligatorio'
                        }
                    ],
                    estado: [
                        value => {
                        if (value) {
                            return true
                        }
                        return 'El campo Estado es obligatorio'
                        }
                    ],
                    tipo_relacion: [
                        value => {
                            if (value) {
                                return true
                            }
                            return 'El campo Tipo de Relación es obligatorio'
                        }
                    ],
                    telefono: [
                        value => {
                            if (value === null || value === undefined || value === '') {
                                return `El campo Teléfono es obligatorio`
                            }
                            const PHONE = value.toString();
                            if (PHONE.length !== 10) {
                                return `El campo debe contener 10 dígitos`
                            }
                            return true
                        }
                    ],
                    nombre_aval: [
                        value => {
                            if (value === null || value === undefined || value === '') {
                                return 'El campo Nombre del Aval es obligatorio'
                            }
                            return true
                        }
                    ],
                }
            },
            infoClient: {
                id_cliente: "...",
                nombre: "...",
                saldo: "...",
                estado: "...",
            },
            typeClassConvenio: 'gray',
            permissions: true,
        }
    },
    computed:{
        ui() {
            const store = useUiStore()
            return store.ui;
        },
        headersAdress(){
            const info = this.ui?.managements;
            if (!info) return []
            return [
                {key: "direccion", title: "Domicilio" }, 
                { key: "num_ext", title: info.direccion.num_ext },  
                { key: "tipo_direccion", title: "Tipo Domicilio" },
                { key: "cp", title: info.direccion.codigoPostal },
                { key: "colonia", title: info.direccion.colonia },
                { key: "poblacion", title: info.direccion.poblacion },
                { key: "estado", title: info.direccion.estado },
                { key: "agregado_por", title: "Agregado por" },
                { key: "actions", title: "Acciones" },
            ]
        }
    },
    async mounted(){
        const store = useUiStore()
        if (Object.keys(store.ui).length === 0) {
            await store.cargarVocabulario()
        }
    },
    async created () {
        const DATA_PARAMS = this.$route.params.form
        if (DATA_PARAMS === null || DATA_PARAMS === undefined || DATA_PARAMS === '') {
            this.isError.hasError = true
            this.isError.msg = `No existen datos en la URL para obtener la información del cliente. Favor de volver a ingresar al cliente`
            return;
        }
        const PARAMS = await EncryptService.decrypt(DATA_PARAMS)
        if (PARAMS === null || PARAMS === '') {
            this.isError.hasError = true
            this.isError.msg = `Los datos de la URL no fueron encriptados correctamente. Favor de volver a ingresar al cliente.`
            return;
        }
        const ARR_PARAMS = JSON.parse(PARAMS);
        this.idClient = ARR_PARAMS.id

        const ENC_TYPE = localStorage.getItem('TIPO');
        const TYPE = await EncryptService.decrypt(ENC_TYPE);
        if (TYPE === 'Gestor' || TYPE === 'Colaborador' || TYPE === 'Supervisor') {
            this.permissions = false;
            this.dataSourceDireccionesAvales.headers.pop();
        }

        this.isLoading = true
        const store = useUiStore()
        if (Object.keys(store.ui).length === 0) {
            await store.cargarVocabulario()
        }
        await this.getClientInformation()
        await this.getDirectionsAvalByClient()
        this.isLoading = false
    },
    methods: {
        getClientInformation: async function () {
            const ENC_CLIENT = await EncryptService.encrypt(this.idClient)
            await ManagementsService.getClientInformation(ENC_CLIENT).then(
                (responseData) => {
                    if (!responseData.error) {
                        this.infoClient = responseData.response
                        this.infoClient.total = ResourcesService.moneyFormat(this.infoClient.total)
                        switch (this.infoClient.estado) {
                            case 'Convenio Activo':
                            case 'Convenio Completado':
                            case 'Pago Intención Activo':
                            case 'Pago Intención Completado':
                                this.typeClassConvenio = 'green';
                                break;
                            case 'Sin convenio':
                                this.typeClassConvenio = 'gray';
                                break;
                            case 'Convenio Cancelado':
                            case 'Pago Intención Cancelado':
                                this.typeClassConvenio = 'red';
                                break;
                            default:
                                this.typeClassConvenio = 'gray';
                        }
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
        },
        getDirectionsAvalByClient: async function () {
            this.isLoading = true
            const ENC_CLIENT = await EncryptService.encrypt(this.idClient)
            await ManagementsService.getDirectionsAvalByClient(ENC_CLIENT).then(
                (responseData) => {
                    if (!responseData.error) {
                        this.dataSourceDireccionesAvales.data = responseData.response
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.isLoading = false
        },
        validateFormDirectionAval: function () {
            let direccion = this.formGroupDireccionAvales.data.direccion
            if (direccion === '' || direccion === null || direccion === undefined) {
                return false
            }
            let num_ext = this.formGroupDireccionAvales.data.num_ext
            if (num_ext === '' || num_ext === null || num_ext === undefined) {
                return false
            }
            let cp = this.formGroupDireccionAvales.data.cp
            if (cp === '' || cp === null || cp === undefined || cp.toString().length < 5) {
                return false
            }
            let colonia = this.formGroupDireccionAvales.data.colonia
            if (colonia === '' || colonia === null || colonia === undefined) {
                return false
            }
            let poblacion = this.formGroupDireccionAvales.data.poblacion
            if (poblacion === '' || poblacion === null || poblacion === undefined) {
                return false
            }
            let estado = this.formGroupDireccionAvales.data.estado
            if (estado === '' || estado === null || estado === undefined) {
                return false
            }
            let tipo_relacion = this.formGroupDireccionAvales.data.tipo_relacion
            if (tipo_relacion === '' || tipo_relacion === null || tipo_relacion === undefined) {
                return false
            }
            let telefono = this.formGroupDireccionAvales.data.telefono
            if (telefono === '' || telefono === null || telefono === undefined || telefono.toString().length < 10) {
                return false
            }
            if (telefono.length !== 10) {
                return false
            }
            let nombre_aval = this.formGroupDireccionAvales.data.nombre_aval
            if (nombre_aval === '' || nombre_aval === null || nombre_aval === undefined) {
                return false
            }
            return true
        },
        clearFormDirectionAval: function () {
            this.formGroupDireccionAvales.data.direccion = ''
            this.formGroupDireccionAvales.data.num_ext = ''
            this.formGroupDireccionAvales.data.num_int = 'N/A'
            this.formGroupDireccionAvales.data.cp = ''
            this.formGroupDireccionAvales.data.colonia = ''
            this.formGroupDireccionAvales.data.poblacion = ''
            this.formGroupDireccionAvales.data.estado = ''
            this.formGroupDireccionAvales.data.tipo_relacion = ''
            this.formGroupDireccionAvales.data.telefono = ''
            this.formGroupDireccionAvales.data.nombre_aval = ''
        },
        createDirectionClientAval: async function () {
            this.isLoading = true
            const REQUEST_FORM = await this.createRequestFormDirectionAval()
            await ManagementsService.createDirectionClientAval(REQUEST_FORM).then(
                async (responseData) => {
                    if (!responseData.error) {
                        this.snackbarData.description = `¡Registro Exitoso!`
                        this.snackbarData.openSnackbar = true
                        this.dialogDirectionAval = false
                        this.dialogSaveDirectionAval = false
                        this.clearFormDirectionAval()
                        await this.getDirectionsAvalByClient()
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.isLoading = false
        },
        createRequestFormDirectionAval: async function () {
            let id_cliente = await EncryptService.encrypt(this.idClient.toString())

            let direccion = this.formGroupDireccionAvales.data.direccion
            direccion = direccion.toString().trim()
            direccion = await EncryptService.encrypt(direccion)

            let num_ext = this.formGroupDireccionAvales.data.num_ext
            num_ext = num_ext.toString().trim()
            num_ext = await EncryptService.encrypt(num_ext)

            let num_int = this.formGroupDireccionAvales.data.num_int
            if (num_int !== '' && num_int !== undefined && num_int !== null && num_int !== 0) {
                num_int = num_int.toString().trim()
                num_int = await EncryptService.encrypt(num_int)
            } else {
                num_int = 'N/A'
            }

            let cp = this.formGroupDireccionAvales.data.cp
            cp = cp.toString().trim()
            cp = await EncryptService.encrypt(cp)

            let colonia = this.formGroupDireccionAvales.data.colonia
            colonia = colonia.toString().trim()
            colonia = await EncryptService.encrypt(colonia)

            let poblacion = this.formGroupDireccionAvales.data.poblacion
            poblacion = poblacion.toString().trim()
            poblacion = await EncryptService.encrypt(poblacion)

            let estado = this.formGroupDireccionAvales.data.estado
            estado = estado.toString().trim()
            estado = await EncryptService.encrypt(estado)

            let tipo_relacion = this.formGroupDireccionAvales.data.tipo_relacion
            tipo_relacion = tipo_relacion.toString().trim()
            tipo_relacion = await EncryptService.encrypt(tipo_relacion)

            let telefono = this.formGroupDireccionAvales.data.telefono
            telefono = telefono.toString().trim()
            telefono = await EncryptService.encrypt(telefono)

            let nombre_aval = this.formGroupDireccionAvales.data.nombre_aval
            nombre_aval = nombre_aval.toString().trim()
            nombre_aval = await EncryptService.encrypt(nombre_aval)

            const USERNAME = localStorage.getItem('USERNAME')

            const REQUEST_FORM = {
                id_cliente: id_cliente,
                direccion: direccion,
                num_ext: num_ext,
                num_int: num_int,
                cp: cp,
                colonia: colonia,
                poblacion: poblacion,
                estado: estado,
                tipo_relacion: tipo_relacion,
                telefono: telefono,
                nombre_aval: nombre_aval,
                agregado_por: USERNAME
            }

            return REQUEST_FORM

        },
        deleteDirectionClientAval: async function () {
            this.isLoading = true
            const ENC_ID = await EncryptService.encrypt(this.typeFormDirectionAval.id.toString())
            await ManagementsService.deleteDirectionClientAval(ENC_ID).then(
                async (responseData) => {
                    if (!responseData.error) {
                        this.snackbarData.description = `¡Eliminación de Domicilio del Aval fue Exitosa!`
                        this.snackbarData.openSnackbar = true
                        this.dialogSaveDirectionAval = false

                        await this.getDirectionsAvalByClient()
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.isLoading = false
            },
            deleteAval: function (item) {
            this.typeFormDirectionAval.type = 'D'
            this.typeFormDirectionAval.id = item.id_direccion
            this.dialogSaveDirectionAval = true
        },
        limitarCPDireccionAval: function () {
            this.formGroupDireccionAvales.data.cp = this.formGroupDireccionAvales.data.cp.replace(/\D/g, '');
            if (this.formGroupDireccionAvales.data.cp.length > 5) {
                this.formGroupDireccionAvales.data.cp = this.formGroupDireccionAvales.data.cp.slice(0, 5);
            }
        },
        limitarTelDireccionAval: function () {
            this.formGroupDireccionAvales.data.telefono = this.formGroupDireccionAvales.data.telefono.replace(/\D/g, '');
            if (this.formGroupDireccionAvales.data.telefono.length > 10) {
                this.formGroupDireccionAvales.data.telefono = this.formGroupDireccionAvales.data.telefono.slice(0, 10);
            }
        },
    }
}
</script>
<style scoped>
    .title_container {
        width: 100%;
        display: flex; 
        justify-content: space-between;
        align-items: center;
        min-height: 50px;
        border-bottom: 1px solid #E3E3E3;
    }
    .title_section {
        width: 25%; 
        display: flex;  
        justify-content: center;
        font-size: 10pt;
    }
    .title_item {
        font-weight: 600;
        margin-right: 4px;
    }
</style>